import { useEffect } from 'react'
import { Sidebar } from 'components/Sidebar/Sidebar'
import { UserProfileCardContainer } from '../UserProfileCard/UserProfileCardContainer'
import { useMemberProfile } from 'hooks/useMemberProfile'
import { useMemberArticles } from 'hooks/useMemberArticles'
import { UserProfileTabs } from './UserProfileTabs'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import Styles from './UserProfileSidebar.module.scss'

interface Props {
  open: boolean
  onClose: () => void
  workspaceId: string | number | undefined
  memberId: number | undefined
  sidebarClassName?: string
}

export const UserProfileSidebar = ({ open, onClose, workspaceId, memberId, sidebarClassName }: Props) => {
  const { profile: currentProfile, error } = useMemberProfile(workspaceId, memberId)
  const { articles, error: articlesError } = useMemberArticles(workspaceId, memberId)

  useEffect(() => {
    if (articlesError) {
      showErrorMessageToast(
        'There was an error fetching the files for this user. Our team has been notified and we are looking into it.',
      )
    }
  }, [articlesError])

  return (
    <Sidebar rootOverrideClassName={sidebarClassName} open={open} onClose={onClose} heading={<h2>Profile</h2>}>
      <div className={Styles.content}>
        <div className={Styles.profileCardContainer}>
          <UserProfileCardContainer reduced profile={currentProfile} error={error} />
          {currentProfile?.bio && currentProfile.bio.length > 1 && <p className={Styles.intro}>{currentProfile.bio}</p>}
        </div>
        {currentProfile && (articles || articlesError) && (
          <UserProfileTabs profile={currentProfile} articles={articles || []} />
        )}
      </div>
    </Sidebar>
  )
}
